var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qyjs_box"},[_c('div',{staticClass:"qyjs_box_bottom"},[_c('img',{staticClass:"img",attrs:{"src":require("../../assets/国家1.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }